function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-execution375"
}, /*#__PURE__*/React.createElement("rect", {
  width: 375,
  height: 250
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "execution375",
  clipPath: "url(#clip-execution375)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_3709",
  "data-name": "Gruppe 3709"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon_2",
  d: "M310.2,116.4a25.97,25.97,0,0,1,0,46.5L185.3,225.3a25.905,25.905,0,0,1-37.6-23.2V77.2a26.051,26.051,0,0,1,37.6-23.3Z",
  transform: "translate(-39.7 -14.619)",
  fill: "#002b47"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_761",
  "data-name": "Rechteck 761",
  width: 375,
  height: 250,
  fill: "none"
})));

function SvgExecution375(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 250,
    viewBox: "0 0 375 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecution375);
export default __webpack_public_path__ + "static/media/execution375.b2bd2e02.svg";
export { ForwardRef as ReactComponent };